import { Component } from "react";
import { connect } from "react-redux";

import { Card, Tooltip, Button, Table, Select, Modal } from "antd";
import { req_list_rts_course, req_list_rts_course_weeklog } from "../../api";
import { usrRole } from "../../utils/dataUtil";
import {
  getNowAcademicYear,
  getNowAcademicSemester,
} from "../../utils/dateUtil";
import CourseStudentOneWeekLogModal from "./course-student-oneweek-log-modal";
const Option = Select.Option;

class CourseStudentEveryweekLog extends Component {
  state = {
    loading: false,
    selectloading: false,
    deviceWidth: 0,
    userLevel: "NORMAL",
    item: {},
    // 分頁參數
    data: [],
    selectitems: [],
    searchField: "NONE",
    searchValue: "",
    filterStatus: "",
    academicYear: getNowAcademicYear(new Date()),
    academicSemester: getNowAcademicSemester(new Date()),
    openCourseSerialKey: "NONE",
    domnloadFile: "",
    isShowModal: false,
    options: [],
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
    this.api_list_select_items();
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
  }

  componentWillUnmount() {
    //
  }

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_list_select_items = async () => {
    const { academicYear, academicSemester } = this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel, selectloading: true });
    const result = await req_list_rts_course(
      userLevel,
      userCode,
      academicYear,
      academicSemester,
      token,
    );
    if (result.total > 0) {
      const items = result.data;
      const options = [];
      items.forEach((element) => {
        options.push({
          value: element.OpenCourseSerialKey,
          label:
            element.OpenCourseSerialKey +
            "-" +
            element.CourseName +
            "-" +
            element.TeacherName +
            "-" +
            element.AcademicYear +
            "-" +
            element.AcademicSemeter,
        });
      });
      this.setState({ options: options, selectloading: false });
      // console.log(options);
    } else {
      const items = [];
      this.setState({
        options: items,
        selectloading: false,
      });
    }
  };

  api_list_items = async () => {
    const { academicYear, academicSemester, openCourseSerialKey } = this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel, loading: true });
    const result = await req_list_rts_course_weeklog(
      userLevel,
      userCode,
      academicYear,
      academicSemester,
      openCourseSerialKey,
      token,
    );
    if (result.total > 0) {
      const items = result.data;
      this.setState({ data: items, loading: false });
      // console.log(options);
    } else {
      const items = [];
      this.setState({
        data: items,
        loading: false,
      });
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "週次",
        dataIndex: "AcademicWeekNum",
        key: "AcademicWeekNum",
        align: "center",
        width: 40,
        render: (text) => (
          <span style={{ fontWeight: "bold", color: "blue" }}>{text}週</span>
        ),
      },
      {
        title: "學年度",
        dataIndex: "AcademicYear",
        key: "AcademicYear",
        align: "center",
        width: 50,
        responsive: ["md"],
        render: (text) => <>{text}</>,
      },
      {
        title: "學期",
        dataIndex: "AcademicSemeter",
        key: "AcademicSemeter",
        align: "center",
        width: 40,
        responsive: ["md"],
        render: (text) => <>{text}</>,
      },
      {
        title: "開課序號",
        dataIndex: "OpenCourseSerialKey",
        key: "OpenCourseSerialKey",
        align: "center",
        width: 50,
        responsive: ["md"],
        render: (text) => <>{text}</>,
      },
      {
        title: "課程名稱",
        dataIndex: "CourseName",
        key: "CourseName",
        responsive: ["md"],
        width: 120,
        render: (text) => <>{text}</>,
      },
      {
        title: "學分",
        dataIndex: "AcademicCredit",
        key: "AcademicCredit",
        align: "center",
        responsive: ["md"],
        width: 40,
        render: (text) => <>{text}</>,
      },
      {
        title: "班級",
        dataIndex: "ClassroomName",
        key: "ClassroomName",
        align: "center",
        responsive: ["md"],
        width: 60,
        render: (text) => <>{text}</>,
      },
      {
        title: "老師",
        dataIndex: "TeacherName",
        key: "TeacherName",
        align: "center",
        width: 50,
        responsive: ["md"],
        render: (text) => <>{text}</>,
      },
      {
        title: "人數",
        align: "center",
        width: 50,
        render: (item) => (
          <>
            {" "}
            <button
              className="btn btn-outline-primary btn-sm"
              style={{ width: "80px" }}
              onClick={() => this.handle_btn_event("list_students", item)}
            >
              <i className="fas fa-users"></i> {item.StudentTotal}
            </button>
          </>
        ),
      },
      {
        title: "學習狀況",
        width: 120,
        render: (item) => (
          <div style={{ textAlign: "center" }}>
            <button
              className={
                item.StudentTotal === item.PassTotal
                  ? "btn btn-success btn-sm"
                  : "btn btn-outline-success btn-sm"
              }
              style={{ width: "80px" }}
              onClick={() => this.handle_btn_event("list_students_pass", item)}
              disabled
            >
              已達標 {item.PassTotal}
            </button>
            <button
              className={
                item.StudentTotal === item.WarningTotal
                  ? "btn btn-danger btn-sm"
                  : "btn btn-outline-danger btn-sm"
              }
              style={{ width: "80px" }}
              onClick={() =>
                this.handle_btn_event("list_students_warning", item)
              }
              disabled
            >
              未達標 {item.WarningTotal}
            </button>
          </div>
        ),
      },
    ];
  };

  // 操作互動處理 //////////////////////////////////////////////

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_list_items();
      },
    );
  };

  handle_data_refresh = () => {
    this.api_list_items();
  };

  handle_btn_event = (modal, item) => {
    switch (modal) {
      case "list_students":
        this.setState({ item, isShowModal: true, item });
        break;
      case "download":
        break;
      default:
    }
  };

  handle_change = (value) => {
    //console.log(`selected ${value}`);
    this.setState({ openCourseSerialKey: value }, () => this.api_list_items());
  };

  /////////////////////////////////////////////////////////////
  render() {
    const { item, data, loading, options, isShowModal, selectloading } =
      this.state;
    const title = (
      <>
        <Select
          placeholder="請選擇查核的課程"
          style={{ width: 250 }}
          onChange={this.handle_change}
          loading={selectloading}
          options={options}
          disabled={selectloading}
        />
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>{" "}
      </>
    );
    return (
      <Card title={title}>
        <Table
          bordered
          rowKey="Uid"
          columns={this.columns}
          dataSource={data}
          pagination={false}
          loading={loading}
        />
        <Modal
          destroyOnClose={true}
          visible={isShowModal}
          width={600}
          onOk={() => {
            this.setState({ isShowModal: false });
          }}
          okText={"關閉"}
          onCancel={() => {
            this.setState({ isShowModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <CourseStudentOneWeekLogModal data={item} />
        </Modal>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {},
)(CourseStudentEveryweekLog);
